import "./chart.css";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";
const DropChart = ({ aspect, title, chartdata5 }) => {

  return (
    <>
      {/* <div className="Buttons">
        <button type="button" className="btn btn-dark" onClick={setFirstButton}>
          7 days
        </button>
        <button
          type="button"
          className="btn btn-dark"
          onClick={() => setSecondButton(setSecondButton)}
        >
          14 days
        </button>
        <button type="button" className="btn btn-dark">
          28Days
        </button>
      </div> */}
      <div className="chart">
        <div className="title">Drop-offs {"(next " + title + ")"}</div>
        <ResponsiveContainer width="100%" aspect={aspect}>
          <AreaChart
            width={730}
            height={250}
            data={chartdata5}
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
          >
            <defs>
              <linearGradient id="upcomingDropoffs" x1="0" y1="0" x2="0" y2="1">
                <stop offset="5%" stopColor="#216ba5" stopOpacity={0.3} />
                <stop offset="95%" stopColor="#216ba5" stopOpacity={0.02} />
              </linearGradient>
            </defs>
            <XAxis dataKey="name" stroke="#94a3b8" />
            <YAxis dataKey="Total" stroke="#94a3b8" />
            <CartesianGrid strokeDasharray="3 3" className="chartGrid" />
            <Tooltip />
            <Area
              type="monotone"
              dataKey="Total"
              stroke="#216ba5"
              strokeWidth={2.5}
              fillOpacity={1}
              fill="url(#upcomingDropoffs)"
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default DropChart;
